import { Dispatch, SetStateAction } from "react";
import AuthClient from "../api/AuthClient";
import GroupsClient from "../api/GroupsClient";
import { parseMyPartyResponse } from "../api/parseResponse/parseMyPartiesResponse";
import SortPartyGroupsByDate from "../SortPartyGroupsByDate";
import { PartyModel } from "../types";

export async function fetchAndSetMyPartiesInfo(
  authClient: AuthClient,
  setMyPartiesInfo: Dispatch<SetStateAction<PartyModel[]>>
): Promise<void> {
  const groupsClient = new GroupsClient(authClient);
  const data = await groupsClient.getMyParties();
  const parsedData = data?.data
    ?.map((el) => el && parseMyPartyResponse(el))
    .filter((p): p is PartyModel => Boolean(p));
  if (parsedData?.length) {
    setMyPartiesInfo(SortPartyGroupsByDate(parsedData));
  }
}

export async function syncMyPartiesAndSelectedPartyFromGroupId(
  authClient: AuthClient,
  groupId: string,
  setSelectedPartyContextData: Dispatch<SetStateAction<PartyModel | null>>,
  setMyPartiesInfoContextData: Dispatch<SetStateAction<PartyModel[]>>
): Promise<void> {
  const groupsClient = new GroupsClient(authClient);
  const refreshedParty = (await groupsClient.getParsedMyPartyById(groupId))?.data;
  if (!refreshedParty) {
    return;
  }

  setSelectedPartyContextData(refreshedParty);
  setMyPartiesInfoContextData((previousParties) =>
    SortPartyGroupsByDate(
      previousParties.some((p) => p.party.id === refreshedParty.party.id)
        ? previousParties.map((p) =>
            p.party.id === refreshedParty.party.id ? refreshedParty : p
          )
        : [...previousParties, refreshedParty]
    )
  );
}
